import { Typography } from "@circle-react-shared/uikit/Typography";

interface FormResponseItemProps {
  answer: string;
  question: string;
}

export const FormResponseItem = ({
  question,
  answer,
}: FormResponseItemProps) => (
  <div className="mt-4 space-y-2">
    <Typography.LabelSm weight="semibold" color="text-primary">
      {question}
    </Typography.LabelSm>
    <Typography.BodySm color="text-tertiary">{answer}</Typography.BodySm>
  </div>
);
